export default "<div>\r\n  <h5>\r\n    <mat-icon>add_alert</mat-icon>\r\n    {{ 'main.success' | translate}}\r\n  </h5>\r\n</div>\r\n\r\n";